import LightBoxManager from '../../../../general/components/LightBox/Manager';

import Button from './Button';

const ResetFavourites = () => (
    <LightBoxManager>
        <Button />
    </LightBoxManager>
);

export default ResetFavourites;
